/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

avi.QueryParser = (function() {
  /*
   * Generated by PEG.js 0.8.0.
   *
   * http://pegjs.majda.cz/
   */

  function peg$subclass(child, parent) {
    function ctor() { this.constructor = child; }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
  }

  function SyntaxError(message, expected, found, offset, line, column) {
    this.message  = message;
    this.expected = expected;
    this.found    = found;
    this.offset   = offset;
    this.line     = line;
    this.column   = column;

    this.name     = "SyntaxError";
  }

  peg$subclass(SyntaxError, Error);

  function parse(input) {
    var options = arguments.length > 1 ? arguments[1] : {},

        peg$FAILED = {},

        peg$startRuleIndices = { start: 0 },
        peg$startRuleIndex   = 0,

        peg$consts = [
          "\"",
          { type: "literal", value: "\"", description: "\"\\\"\"" },
          "'",
          { type: "literal", value: "'", description: "\"'\"" },
          [],
          peg$FAILED,
          /^[ ]/,
          { type: "class", value: "[ ]", description: "[ ]" },
          /^[a-zA-Z0-9]/,
          { type: "class", value: "[a-zA-Z0-9]", description: "[a-zA-Z0-9]" },
          /^[`~!@#$%\^&*()-_=+{[}\]|\\;:,<.>\/?]/,
          { type: "class", value: "[`~!@#$%\\^&*()-_=+{[}\\]|\\\\;:,<.>\\/?]", description: "[`~!@#$%\\^&*()-_=+{[}\\]|\\\\;:,<.>\\/?]" },
          " ",
          { type: "literal", value: " ", description: "\" \"" },
          function(chars) {
              return chars.join('');
            },
          null,
          "-",
          { type: "literal", value: "-", description: "\"-\"" },
          /^[0-9]/,
          { type: "class", value: "[0-9]", description: "[0-9]" },
          ".",
          { type: "literal", value: ".", description: "\".\"" },
          function(negative, integral, fractional) {
              return parseNumber(negative, integral, fractional);
            },
          "\"NO_DATA\"",
          { type: "literal", value: "\"NO_DATA\"", description: "\"\\\"NO_DATA\\\"\"" },
          "'NO_DATA'",
          { type: "literal", value: "'NO_DATA'", description: "\"'NO_DATA'\"" },
          "NO_DATA",
          { type: "literal", value: "NO_DATA", description: "\"NO_DATA\"" },
          "false",
          { type: "literal", value: "false", description: "\"false\"" },
          "'false'",
          { type: "literal", value: "'false'", description: "\"'false'\"" },
          "\"false\"",
          { type: "literal", value: "\"false\"", description: "\"\\\"false\\\"\"" },
          "true",
          { type: "literal", value: "true", description: "\"true\"" },
          "'true'",
          { type: "literal", value: "'true'", description: "\"'true'\"" },
          "\"true\"",
          { type: "literal", value: "\"true\"", description: "\"\\\"true\\\"\"" },
          "0",
          { type: "literal", value: "0", description: "\"0\"" },
          "'0'",
          { type: "literal", value: "'0'", description: "\"'0'\"" },
          "\"0\"",
          { type: "literal", value: "\"0\"", description: "\"\\\"0\\\"\"" },
          "1",
          { type: "literal", value: "1", description: "\"1\"" },
          "'1'",
          { type: "literal", value: "'1'", description: "\"'1'\"" },
          "\"1\"",
          { type: "literal", value: "\"1\"", description: "\"\\\"1\\\"\"" },
          ",",
          { type: "literal", value: ",", description: "\",\"" },
          function(str) {
              return str;
          },
          /^[([]/,
          { type: "class", value: "[([]", description: "[([]" },
          /^[)\]]/,
          { type: "class", value: "[)\\]]", description: "[)\\]]" },
          function(first, second) {
              return [first].concat(second);
          },
          "obj_type",
          { type: "literal", value: "obj_type", description: "\"obj_type\"" },
          "event_id",
          { type: "literal", value: "event_id", description: "\"event_id\"" },
          "module",
          { type: "literal", value: "module", description: "\"module\"" },
          "obj_name",
          { type: "literal", value: "obj_name", description: "\"obj_name\"" },
          "reason_code",
          { type: "literal", value: "reason_code", description: "\"reason_code\"" },
          "client_src_port",
          { type: "literal", value: "client_src_port", description: "\"client_src_port\"" },
          "client_dest_port",
          { type: "literal", value: "client_dest_port", description: "\"client_dest_port\"" },
          "total_time",
          { type: "literal", value: "total_time", description: "\"total_time\"" },
          "rtt",
          { type: "literal", value: "rtt", description: "\"rtt\"" },
          "mss",
          { type: "literal", value: "mss", description: "\"mss\"" },
          "rx_bytes",
          { type: "literal", value: "rx_bytes", description: "\"rx_bytes\"" },
          "tx_bytes",
          { type: "literal", value: "tx_bytes", description: "\"tx_bytes\"" },
          "total_bytes",
          { type: "literal", value: "total_bytes", description: "\"total_bytes\"" },
          "rx_pkts",
          { type: "literal", value: "rx_pkts", description: "\"rx_pkts\"" },
          "tx_pkts",
          { type: "literal", value: "tx_pkts", description: "\"tx_pkts\"" },
          "total_pkts",
          { type: "literal", value: "total_pkts", description: "\"total_pkts\"" },
          "out_of_orders",
          { type: "literal", value: "out_of_orders", description: "\"out_of_orders\"" },
          "retransmits",
          { type: "literal", value: "retransmits", description: "\"retransmits\"" },
          "timeouts",
          { type: "literal", value: "timeouts", description: "\"timeouts\"" },
          "zero_window_size_events",
          { type: "literal", value: "zero_window_size_events", description: "\"zero_window_size_events\"" },
          "vcpu_id",
          { type: "literal", value: "vcpu_id", description: "\"vcpu_id\"" },
          "server_dest_port",
          { type: "literal", value: "server_dest_port", description: "\"server_dest_port\"" },
          "server_src_port",
          { type: "literal", value: "server_src_port", description: "\"server_src_port\"" },
          "server_rtt",
          { type: "literal", value: "server_rtt", description: "\"server_rtt\"" },
          "server_total_bytes",
          { type: "literal", value: "server_total_bytes", description: "\"server_total_bytes\"" },
          "server_rx_bytes",
          { type: "literal", value: "server_rx_bytes", description: "\"server_rx_bytes\"" },
          "server_tx_bytes",
          { type: "literal", value: "server_tx_bytes", description: "\"server_tx_bytes\"" },
          "server_total_pkts",
          { type: "literal", value: "server_total_pkts", description: "\"server_total_pkts\"" },
          "server_rx_pkts",
          { type: "literal", value: "server_rx_pkts", description: "\"server_rx_pkts\"" },
          "server_tx_pkts",
          { type: "literal", value: "server_tx_pkts", description: "\"server_tx_pkts\"" },
          "server_out_of_orders",
          { type: "literal", value: "server_out_of_orders", description: "\"server_out_of_orders\"" },
          "server_retransmits",
          { type: "literal", value: "server_retransmits", description: "\"server_retransmits\"" },
          "server_timeouts",
          { type: "literal", value: "server_timeouts", description: "\"server_timeouts\"" },
          "server_zero_window_size_events",
          { type: "literal", value: "server_zero_window_size_events", description: "\"server_zero_window_size_events\"" },
          "dns_request.identifier",
          { type: "literal", value: "dns_request.identifier", description: "\"dns_request.identifier\"" },
          "dns_request.question_count",
          { type: "literal", value: "dns_request.question_count", description: "\"dns_request.question_count\"" },
          "dns_request.opt_record.version",
          { type: "literal", value: "dns_request.opt_record.version", description: "\"dns_request.opt_record.version\"" },
          "dns_request.opt_record.udp_payload_size",
          { type: "literal", value: "dns_request.opt_record.udp_payload_size", description: "\"dns_request.opt_record.udp_payload_size\"" },
          "dns_request.opt_record.options.source_prefix_len",
          { type: "literal", value: "dns_request.opt_record.options.source_prefix_len", description: "\"dns_request.opt_record.options.source_prefix_len\"" },
          "dns_request.opt_record.options.scope_prefix_len",
          { type: "literal", value: "dns_request.opt_record.options.scope_prefix_len", description: "\"dns_request.opt_record.options.scope_prefix_len\"" },
          "dns_response.question_count",
          { type: "literal", value: "dns_response.question_count", description: "\"dns_response.question_count\"" },
          "dns_response.answer_records_count",
          { type: "literal", value: "dns_response.answer_records_count", description: "\"dns_response.answer_records_count\"" },
          "dns_response.nameserver_records_count",
          { type: "literal", value: "dns_response.nameserver_records_count", description: "\"dns_response.nameserver_records_count\"" },
          "dns_response.additional_records_count",
          { type: "literal", value: "dns_response.additional_records_count", description: "\"dns_response.additional_records_count\"" },
          "dns_response.opt_record.version",
          { type: "literal", value: "dns_response.opt_record.version", description: "\"dns_response.opt_record.version\"" },
          "dns_response.opt_record.udp_payload_size",
          { type: "literal", value: "dns_response.opt_record.udp_payload_size", description: "\"dns_response.opt_record.udp_payload_size\"" },
          "dns_response.opt_record.options.source_prefix_len",
          { type: "literal", value: "dns_response.opt_record.options.source_prefix_len", description: "\"dns_response.opt_record.options.source_prefix_len\"" },
          "dns_response.opt_record.options.scope_prefix_len",
          { type: "literal", value: "dns_response.opt_record.options.scope_prefix_len", description: "\"dns_response.opt_record.options.scope_prefix_len\"" },
          "dns_response.records.ttl",
          { type: "literal", value: "dns_response.records.ttl", description: "\"dns_response.records.ttl\"" },
          "dns_response.records.port",
          { type: "literal", value: "dns_response.records.port", description: "\"dns_response.records.port\"" },
          "dns_response.records.priority",
          { type: "literal", value: "dns_response.records.priority", description: "\"dns_response.records.priority\"" },
          function(variable) {
              return setLastVariable(variable, 'number');
            },
          "significance",
          { type: "literal", value: "significance", description: "\"significance\"" },
          "client_ip6",
          { type: "literal", value: "client_ip6", description: "\"client_ip6\"" },
          "server_ip6",
          { type: "literal", value: "server_ip6", description: "\"server_ip6\"" },
          "server_conn_src_ip6",
          { type: "literal", value: "server_conn_src_ip6", description: "\"server_conn_src_ip6\"" },
          "vs_ip6",
          { type: "literal", value: "vs_ip6", description: "\"vs_ip6\"" },
          "client_location",
          { type: "literal", value: "client_location", description: "\"client_location\"" },
          "client_ip",
          { type: "literal", value: "client_ip", description: "\"client_ip\"" },
          "server_ip",
          { type: "literal", value: "server_ip", description: "\"server_ip\"" },
          "server_conn_src_ip",
          { type: "literal", value: "server_conn_src_ip", description: "\"server_conn_src_ip\"" },
          "service_engine",
          { type: "literal", value: "service_engine", description: "\"service_engine\"" },
          "network_security_policy_rule_name",
          { type: "literal", value: "network_security_policy_rule_name", description: "\"network_security_policy_rule_name\"" },
          "pool",
          { type: "literal", value: "pool", description: "\"pool\"" },
          "pool_name",
          { type: "literal", value: "pool_name", description: "\"pool_name\"" },
          "server_name",
          { type: "literal", value: "server_name", description: "\"server_name\"" },
          "microservice_name",
          { type: "literal", value: "microservice_name", description: "\"microservice_name\"" },
          "microservice",
          { type: "literal", value: "microservice", description: "\"microservice\"" },
          "dns_qtype",
          { type: "literal", value: "dns_qtype", description: "\"dns_qtype\"" },
          "gslbservice_name",
          { type: "literal", value: "gslbservice_name", description: "\"gslbservice_name\"" },
          "gslbpool_name",
          { type: "literal", value: "gslbpool_name", description: "\"gslbpool_name\"" },
          "gslbservice",
          { type: "literal", value: "gslbservice", description: "\"gslbservice\"" },
          "dns_fqdn",
          { type: "literal", value: "dns_fqdn", description: "\"dns_fqdn\"" },
          "protocol",
          { type: "literal", value: "protocol", description: "\"protocol\"" },
          "dns_etype",
          { type: "literal", value: "dns_etype", description: "\"dns_etype\"" },
          "vs_ip",
          { type: "literal", value: "vs_ip", description: "\"vs_ip\"" },
          "sni_hostname",
          { type: "literal", value: "sni_hostname", description: "\"sni_hostname\"" },
          "ssl_session_id",
          { type: "literal", value: "ssl_session_id", description: "\"ssl_session_id\"" },
          "ssl_cipher",
          { type: "literal", value: "ssl_cipher", description: "\"ssl_cipher\"" },
          "ssl_version",
          { type: "literal", value: "ssl_version", description: "\"ssl_version\"" },
          "dns_request.opt_record.options.subnet_ip",
          { type: "literal", value: "dns_request.opt_record.options.subnet_ip", description: "\"dns_request.opt_record.options.subnet_ip\"" },
          "dns_request.opt_record.options.subnet_ip6",
          { type: "literal", value: "dns_request.opt_record.options.subnet_ip6", description: "\"dns_request.opt_record.options.subnet_ip6\"" },
          "dns_request.client_location.name",
          { type: "literal", value: "dns_request.client_location.name", description: "\"dns_request.client_location.name\"" },
          "dns_request.opcode",
          { type: "literal", value: "dns_request.opcode", description: "\"dns_request.opcode\"" },
          "dns_request.opt_record.options.code",
          { type: "literal", value: "dns_request.opt_record.options.code", description: "\"dns_request.opt_record.options.code\"" },
          "dns_response.response_code",
          { type: "literal", value: "dns_response.response_code", description: "\"dns_response.response_code\"" },
          "dns_response.opcode",
          { type: "literal", value: "dns_response.opcode", description: "\"dns_response.opcode\"" },
          "dns_response.opt_record.options.code",
          { type: "literal", value: "dns_response.opt_record.options.code", description: "\"dns_response.opt_record.options.code\"" },
          "dns_response.records.name",
          { type: "literal", value: "dns_response.records.name", description: "\"dns_response.records.name\"" },
          "dns_response.records.type",
          { type: "literal", value: "dns_response.records.type", description: "\"dns_response.records.type\"" },
          "dns_response.records.vs_name",
          { type: "literal", value: "dns_response.records.vs_name", description: "\"dns_response.records.vs_name\"" },
          "dns_response.records.location.name",
          { type: "literal", value: "dns_response.records.location.name", description: "\"dns_response.records.location.name\"" },
          "dns_response.records.nsname",
          { type: "literal", value: "dns_response.records.nsname", description: "\"dns_response.records.nsname\"" },
          "dns_response.records.addr6_ip_str",
          { type: "literal", value: "dns_response.records.addr6_ip_str", description: "\"dns_response.records.addr6_ip_str\"" },
          "dns_response.records.addr_ip",
          { type: "literal", value: "dns_response.records.addr_ip", description: "\"dns_response.records.addr_ip\"" },
          "dns_response.records.cname",
          { type: "literal", value: "dns_response.records.cname", description: "\"dns_response.records.cname\"" },
          "dns_response.records.mail_server",
          { type: "literal", value: "dns_response.records.mail_server", description: "\"dns_response.records.mail_server\"" },
          "dns_response.records.text_rdata",
          { type: "literal", value: "dns_response.records.text_rdata", description: "\"dns_response.records.text_rdata\"" },
          "ds_log",
          { type: "literal", value: "ds_log", description: "\"ds_log\"" },
          function(variable) {
              return setLastVariable(variable, 'string');
            },
          "connection_ended",
          { type: "literal", value: "connection_ended", description: "\"connection_ended\"" },
          "ocsp_status_resp_sent",
          { type: "literal", value: "ocsp_status_resp_sent", description: "\"ocsp_status_resp_sent\"" },
          "dns_request.authentic_data",
          { type: "literal", value: "dns_request.authentic_data", description: "\"dns_request.authentic_data\"" },
          "dns_request.recursion_desired",
          { type: "literal", value: "dns_request.recursion_desired", description: "\"dns_request.recursion_desired\"" },
          "dns_request.checking_disabled",
          { type: "literal", value: "dns_request.checking_disabled", description: "\"dns_request.checking_disabled\"" },
          "dns_request.opt_record.dnssec_ok",
          { type: "literal", value: "dns_request.opt_record.dnssec_ok", description: "\"dns_request.opt_record.dnssec_ok\"" },
          "dns_response.truncation",
          { type: "literal", value: "dns_response.truncation", description: "\"dns_response.truncation\"" },
          "dns_response.authoritative_answer",
          { type: "literal", value: "dns_response.authoritative_answer", description: "\"dns_response.authoritative_answer\"" },
          "dns_response.recursion_available",
          { type: "literal", value: "dns_response.recursion_available", description: "\"dns_response.recursion_available\"" },
          "dns_response.recursion_desired",
          { type: "literal", value: "dns_response.recursion_desired", description: "\"dns_response.recursion_desired\"" },
          "dns_response.is_wildcard",
          { type: "literal", value: "dns_response.is_wildcard", description: "\"dns_response.is_wildcard\"" },
          "dns_response.fallback_algorithm_used",
          { type: "literal", value: "dns_response.fallback_algorithm_used", description: "\"dns_response.fallback_algorithm_used\"" },
          "dns_response.opt_record.dnssec_ok",
          { type: "literal", value: "dns_response.opt_record.dnssec_ok", description: "\"dns_response.opt_record.dnssec_ok\"" },
          "query_or_response",
          { type: "literal", value: "query_or_response", description: "\"query_or_response\"" },
          function(variable) {
              return setLastVariable(variable, 'bool');
            },
          "client_rtt",
          { type: "literal", value: "client_rtt", description: "\"client_rtt\"" },
          "request_length",
          { type: "literal", value: "request_length", description: "\"request_length\"" },
          "server_response_length",
          { type: "literal", value: "server_response_length", description: "\"server_response_length\"" },
          "server_response_code",
          { type: "literal", value: "server_response_code", description: "\"server_response_code\"" },
          "app_response_time",
          { type: "literal", value: "app_response_time", description: "\"app_response_time\"" },
          "response_length",
          { type: "literal", value: "response_length", description: "\"response_length\"" },
          "response_code",
          { type: "literal", value: "response_code", description: "\"response_code\"" },
          "data_transfer_time",
          { type: "literal", value: "data_transfer_time", description: "\"data_transfer_time\"" },
          "compression_percentage",
          { type: "literal", value: "compression_percentage", description: "\"compression_percentage\"" },
          "waf_log.latency_request_header_phase",
          { type: "literal", value: "waf_log.latency_request_header_phase", description: "\"waf_log.latency_request_header_phase\"" },
          "waf_log.latency_request_body_phase",
          { type: "literal", value: "waf_log.latency_request_body_phase", description: "\"waf_log.latency_request_body_phase\"" },
          "waf_log.latency_response_header_phase",
          { type: "literal", value: "waf_log.latency_response_header_phase", description: "\"waf_log.latency_response_header_phase\"" },
          "waf_log.latency_response_body_phase",
          { type: "literal", value: "waf_log.latency_response_body_phase", description: "\"waf_log.latency_response_body_phase\"" },
          "waf_log.rule_logs.rule_id",
          { type: "literal", value: "waf_log.rule_logs.rule_id", description: "\"waf_log.rule_logs.rule_id\"" },
          "paa_log.request_logs.response_code",
          { type: "literal", value: "paa_log.request_logs.response_code", description: "\"paa_log.request_logs.response_code\"" },
          "paa_log.request_logs.servers_tried",
          { type: "literal", value: "paa_log.request_logs.servers_tried", description: "\"paa_log.request_logs.servers_tried\"" },
          "grpc_status",
          { type: "literal", value: "grpc_status", description: "\"grpc_status\"" },
          "icap_log.request_logs.source_port",
          { type: "literal", value: "icap_log.request_logs.source_port", description: "\"icap_log.request_logs.source_port\"" },
          "icap_log.request_logs.icap_response_code",
          { type: "literal", value: "icap_log.request_logs.icap_response_code", description: "\"icap_log.request_logs.icap_response_code\"" },
          "icap_log.request_logs.http_response_code",
          { type: "literal", value: "icap_log.request_logs.http_response_code", description: "\"icap_log.request_logs.http_response_code\"" },
          "icap_log.request_logs.latency",
          { type: "literal", value: "icap_log.request_logs.latency", description: "\"icap_log.request_logs.latency\"" },
          "icap_log.request_logs.modified_content_length",
          { type: "literal", value: "icap_log.request_logs.modified_content_length", description: "\"icap_log.request_logs.modified_content_length\"" },
          "icap_log.request_logs.nsx_defender_log.score",
          { type: "literal", value: "icap_log.request_logs.nsx_defender_log.score", description: "\"icap_log.request_logs.nsx_defender_log.score\"" },
          "oob_log.ds_req_logs.http_response_code",
          { type: "literal", value: "oob_log.ds_req_logs.http_response_code", description: "\"oob_log.ds_req_logs.http_response_code\"" },
          "oob_log.ds_req_logs.server_port",
          { type: "literal", value: "oob_log.ds_req_logs.server_port", description: "\"oob_log.ds_req_logs.server_port\"" },
          "oob_log.ds_req_logs.source_port",
          { type: "literal", value: "oob_log.ds_req_logs.source_port", description: "\"oob_log.ds_req_logs.source_port\"" },
          "oob_log.ds_req_logs.servers_tried",
          { type: "literal", value: "oob_log.ds_req_logs.servers_tried", description: "\"oob_log.ds_req_logs.servers_tried\"" },
          "oob_log.ds_req_logs.request_length",
          { type: "literal", value: "oob_log.ds_req_logs.request_length", description: "\"oob_log.ds_req_logs.request_length\"" },
          "oob_log.ds_req_logs.response_length",
          { type: "literal", value: "oob_log.ds_req_logs.response_length", description: "\"oob_log.ds_req_logs.response_length\"" },
          "oob_log.ds_req_logs.total_time",
          { type: "literal", value: "oob_log.ds_req_logs.total_time", description: "\"oob_log.ds_req_logs.total_time\"" },
          "persistent_session_id",
          { type: "literal", value: "persistent_session_id", description: "\"persistent_session_id\"" },
          "oauth_log.token_introspection_subrequest.sub_request_log.server_port",
          { type: "literal", value: "oauth_log.token_introspection_subrequest.sub_request_log.server_port", description: "\"oauth_log.token_introspection_subrequest.sub_request_log.server_port\"" },
          "oauth_log.token_introspection_subrequest.sub_request_log.source_port",
          { type: "literal", value: "oauth_log.token_introspection_subrequest.sub_request_log.source_port", description: "\"oauth_log.token_introspection_subrequest.sub_request_log.source_port\"" },
          "oauth_log.token_introspection_subrequest.sub_request_log.http_response_code",
          { type: "literal", value: "oauth_log.token_introspection_subrequest.sub_request_log.http_response_code", description: "\"oauth_log.token_introspection_subrequest.sub_request_log.http_response_code\"" },
          "oauth_log.token_introspection_subrequest.sub_request_log.total_time",
          { type: "literal", value: "oauth_log.token_introspection_subrequest.sub_request_log.total_time", description: "\"oauth_log.token_introspection_subrequest.sub_request_log.total_time\"" },
          "oauth_log.jwks_subrequest.sub_request_log.server_port",
          { type: "literal", value: "oauth_log.jwks_subrequest.sub_request_log.server_port", description: "\"oauth_log.jwks_subrequest.sub_request_log.server_port\"" },
          "oauth_log.jwks_subrequest.sub_request_log.source_port",
          { type: "literal", value: "oauth_log.jwks_subrequest.sub_request_log.source_port", description: "\"oauth_log.jwks_subrequest.sub_request_log.source_port\"" },
          "oauth_log.jwks_subrequest.sub_request_log.http_response_code",
          { type: "literal", value: "oauth_log.jwks_subrequest.sub_request_log.http_response_code", description: "\"oauth_log.jwks_subrequest.sub_request_log.http_response_code\"" },
          "oauth_log.jwks_subrequest.sub_request_log.total_time",
          { type: "literal", value: "oauth_log.jwks_subrequest.sub_request_log.total_time", description: "\"oauth_log.jwks_subrequest.sub_request_log.total_time\"" },
          "oauth_log.token_exchange_subrequest.sub_request_log.server_port",
          { type: "literal", value: "oauth_log.token_exchange_subrequest.sub_request_log.server_port", description: "\"oauth_log.token_exchange_subrequest.sub_request_log.server_port\"" },
          "oauth_log.token_exchange_subrequest.sub_request_log.source_port",
          { type: "literal", value: "oauth_log.token_exchange_subrequest.sub_request_log.source_port", description: "\"oauth_log.token_exchange_subrequest.sub_request_log.source_port\"" },
          "oauth_log.token_exchange_subrequest.sub_request_log.http_response_code",
          { type: "literal", value: "oauth_log.token_exchange_subrequest.sub_request_log.http_response_code", description: "\"oauth_log.token_exchange_subrequest.sub_request_log.http_response_code\"" },
          "oauth_log.token_exchange_subrequest.sub_request_log.total_time",
          { type: "literal", value: "oauth_log.token_exchange_subrequest.sub_request_log.total_time", description: "\"oauth_log.token_exchange_subrequest.sub_request_log.total_time\"" },
          "oauth_log.token_refresh_subrequest.sub_request_log.server_port",
          { type: "literal", value: "oauth_log.token_refresh_subrequest.sub_request_log.server_port", description: "\"oauth_log.token_refresh_subrequest.sub_request_log.server_port\"" },
          "oauth_log.token_refresh_subrequest.sub_request_log.source_port",
          { type: "literal", value: "oauth_log.token_refresh_subrequest.sub_request_log.source_port", description: "\"oauth_log.token_refresh_subrequest.sub_request_log.source_port\"" },
          "oauth_log.token_refresh_subrequest.sub_request_log.http_response_code",
          { type: "literal", value: "oauth_log.token_refresh_subrequest.sub_request_log.http_response_code", description: "\"oauth_log.token_refresh_subrequest.sub_request_log.http_response_code\"" },
          "oauth_log.token_refresh_subrequest.sub_request_log.total_time",
          { type: "literal", value: "oauth_log.token_refresh_subrequest.sub_request_log.total_time", description: "\"oauth_log.token_refresh_subrequest.sub_request_log.total_time\"" },
          "oauth_log.userinfo_subrequest.sub_request_log.server_port",
          { type: "literal", value: "oauth_log.userinfo_subrequest.sub_request_log.server_port", description: "\"oauth_log.userinfo_subrequest.sub_request_log.server_port\"" },
          "oauth_log.userinfo_subrequest.sub_request_log.source_port",
          { type: "literal", value: "oauth_log.userinfo_subrequest.sub_request_log.source_port", description: "\"oauth_log.userinfo_subrequest.sub_request_log.source_port\"" },
          "oauth_log.userinfo_subrequest.sub_request_log.http_response_code",
          { type: "literal", value: "oauth_log.userinfo_subrequest.sub_request_log.http_response_code", description: "\"oauth_log.userinfo_subrequest.sub_request_log.http_response_code\"" },
          "oauth_log.userinfo_subrequest.sub_request_log.total_time",
          { type: "literal", value: "oauth_log.userinfo_subrequest.sub_request_log.total_time", description: "\"oauth_log.userinfo_subrequest.sub_request_log.total_time\"" },
          "icap_log.request_logs.server_port",
          { type: "literal", value: "icap_log.request_logs.server_port", description: "\"icap_log.request_logs.server_port\"" },
          "http2_stream_id",
          { type: "literal", value: "http2_stream_id", description: "\"http2_stream_id\"" },
          "servers_tried",
          { type: "literal", value: "servers_tried", description: "\"servers_tried\"" },
          "waf_log.memory_allocated",
          { type: "literal", value: "waf_log.memory_allocated", description: "\"waf_log.memory_allocated\"" },
          "datascript_log",
          { type: "literal", value: "datascript_log", description: "\"datascript_log\"" },
          "source_ip6",
          { type: "literal", value: "source_ip6", description: "\"source_ip6\"" },
          "http_version",
          { type: "literal", value: "http_version", description: "\"http_version\"" },
          "method",
          { type: "literal", value: "method", description: "\"method\"" },
          "unparsed_uri",
          { type: "literal", value: "unparsed_uri", description: "\"unparsed_uri\"" },
          "uri_path",
          { type: "literal", value: "uri_path", description: "\"uri_path\"" },
          "uri_query",
          { type: "literal", value: "uri_query", description: "\"uri_query\"" },
          "referer",
          { type: "literal", value: "referer", description: "\"referer\"" },
          "user_agent",
          { type: "literal", value: "user_agent", description: "\"user_agent\"" },
          "client_device",
          { type: "literal", value: "client_device", description: "\"client_device\"" },
          "client_browser",
          { type: "literal", value: "client_browser", description: "\"client_browser\"" },
          "client_os",
          { type: "literal", value: "client_os", description: "\"client_os\"" },
          "xff",
          { type: "literal", value: "xff", description: "\"xff\"" },
          "persistent_cookie",
          { type: "literal", value: "persistent_cookie", description: "\"persistent_cookie\"" },
          "host",
          { type: "literal", value: "host", description: "\"host\"" },
          "etag",
          { type: "literal", value: "etag", description: "\"etag\"" },
          "http_security_policy_rule_name",
          { type: "literal", value: "http_security_policy_rule_name", description: "\"http_security_policy_rule_name\"" },
          "http_request_policy_rule_name",
          { type: "literal", value: "http_request_policy_rule_name", description: "\"http_request_policy_rule_name\"" },
          "http_response_policy_rule_name",
          { type: "literal", value: "http_response_policy_rule_name", description: "\"http_response_policy_rule_name\"" },
          "source_ip",
          { type: "literal", value: "source_ip", description: "\"source_ip\"" },
          "response_content_type",
          { type: "literal", value: "response_content_type", description: "\"response_content_type\"" },
          "request_content_type",
          { type: "literal", value: "request_content_type", description: "\"request_content_type\"" },
          "rewritten_uri_path",
          { type: "literal", value: "rewritten_uri_path", description: "\"rewritten_uri_path\"" },
          "rewritten_uri_query",
          { type: "literal", value: "rewritten_uri_query", description: "\"rewritten_uri_query\"" },
          "redirected_uri",
          { type: "literal", value: "redirected_uri", description: "\"redirected_uri\"" },
          "server_side_redirect_uri",
          { type: "literal", value: "server_side_redirect_uri", description: "\"server_side_redirect_uri\"" },
          "spdy_version",
          { type: "literal", value: "spdy_version", description: "\"spdy_version\"" },
          "user_id",
          { type: "literal", value: "user_id", description: "\"user_id\"" },
          "waf_log.learning_status",
          { type: "literal", value: "waf_log.learning_status", description: "\"waf_log.learning_status\"" },
          "waf_log.rule_logs.rule_group",
          { type: "literal", value: "waf_log.rule_logs.rule_group", description: "\"waf_log.rule_logs.rule_group\"" },
          "waf_log.rule_logs.tags",
          { type: "literal", value: "waf_log.rule_logs.tags", description: "\"waf_log.rule_logs.tags\"" },
          "waf_log.status",
          { type: "literal", value: "waf_log.status", description: "\"waf_log.status\"" },
          "waf_log.used_body_parser",
          { type: "literal", value: "waf_log.used_body_parser", description: "\"waf_log.used_body_parser\"" },
          "waf_log.rule_logs.matches.match_element",
          { type: "literal", value: "waf_log.rule_logs.matches.match_element", description: "\"waf_log.rule_logs.matches.match_element\"" },
          "waf_log.rule_logs.rule_name",
          { type: "literal", value: "waf_log.rule_logs.rule_name", description: "\"waf_log.rule_logs.rule_name\"" },
          "paa_log.request_logs.http_version",
          { type: "literal", value: "paa_log.request_logs.http_version", description: "\"paa_log.request_logs.http_version\"" },
          "paa_log.request_logs.method",
          { type: "literal", value: "paa_log.request_logs.method", description: "\"paa_log.request_logs.method\"" },
          "paa_log.request_logs.server_ip",
          { type: "literal", value: "paa_log.request_logs.server_ip", description: "\"paa_log.request_logs.server_ip\"" },
          "paa_log.request_logs.pool_name",
          { type: "literal", value: "paa_log.request_logs.pool_name", description: "\"paa_log.request_logs.pool_name\"" },
          "paa_log.request_logs.uri_path",
          { type: "literal", value: "paa_log.request_logs.uri_path", description: "\"paa_log.request_logs.uri_path\"" },
          "paa_log.request_logs.headers_received_from_server",
          { type: "literal", value: "paa_log.request_logs.headers_received_from_server", description: "\"paa_log.request_logs.headers_received_from_server\"" },
          "paa_log.request_logs.headers_sent_to_server",
          { type: "literal", value: "paa_log.request_logs.headers_sent_to_server", description: "\"paa_log.request_logs.headers_sent_to_server\"" },
          "request_id",
          { type: "literal", value: "request_id", description: "\"request_id\"" },
          "grpc_status_label",
          { type: "literal", value: "grpc_status_label", description: "\"grpc_status_label\"" },
          "icap_log.action",
          { type: "literal", value: "icap_log.action", description: "\"icap_log.action\"" },
          "icap_log.request_logs.action",
          { type: "literal", value: "icap_log.request_logs.action", description: "\"icap_log.request_logs.action\"" },
          "icap_log.request_logs.icap_server_ip",
          { type: "literal", value: "icap_log.request_logs.icap_server_ip", description: "\"icap_log.request_logs.icap_server_ip\"" },
          "icap_log.request_logs.opswat_log.reason",
          { type: "literal", value: "icap_log.request_logs.opswat_log.reason", description: "\"icap_log.request_logs.opswat_log.reason\"" },
          "icap_log.request_logs.http_method",
          { type: "literal", value: "icap_log.request_logs.http_method", description: "\"icap_log.request_logs.http_method\"" },
          "icap_log.request_logs.icap_method",
          { type: "literal", value: "icap_log.request_logs.icap_method", description: "\"icap_log.request_logs.icap_method\"" },
          "icap_log.request_logs.opswat_log.threat_id",
          { type: "literal", value: "icap_log.request_logs.opswat_log.threat_id", description: "\"icap_log.request_logs.opswat_log.threat_id\"" },
          "icap_log.request_logs.pool_name",
          { type: "literal", value: "icap_log.request_logs.pool_name", description: "\"icap_log.request_logs.pool_name\"" },
          "icap_log.request_logs.icap_absolute_uri",
          { type: "literal", value: "icap_log.request_logs.icap_absolute_uri", description: "\"icap_log.request_logs.icap_absolute_uri\"" },
          "icap_log.request_logs.vendor",
          { type: "literal", value: "icap_log.request_logs.vendor", description: "\"icap_log.request_logs.vendor\"" },
          "icap_log.request_logs.opswat_log.violations.file_name",
          { type: "literal", value: "icap_log.request_logs.opswat_log.violations.file_name", description: "\"icap_log.request_logs.opswat_log.violations.file_name\"" },
          "icap_log.request_logs.opswat_log.violations.threat_name",
          { type: "literal", value: "icap_log.request_logs.opswat_log.violations.threat_name", description: "\"icap_log.request_logs.opswat_log.violations.threat_name\"" },
          "icap_log.request_logs.opswat_log.violations.resolution",
          { type: "literal", value: "icap_log.request_logs.opswat_log.violations.resolution", description: "\"icap_log.request_logs.opswat_log.violations.resolution\"" },
          "icap_log.request_logs.nsx_defender_log.task_uuid",
          { type: "literal", value: "icap_log.request_logs.nsx_defender_log.task_uuid", description: "\"icap_log.request_logs.nsx_defender_log.task_uuid\"" },
          "icap_log.request_logs.nsx_defender_log.status_url",
          { type: "literal", value: "icap_log.request_logs.nsx_defender_log.status_url", description: "\"icap_log.request_logs.nsx_defender_log.status_url\"" },
          "oob_log.ds_req_logs.ds_name",
          { type: "literal", value: "oob_log.ds_req_logs.ds_name", description: "\"oob_log.ds_req_logs.ds_name\"" },
          "oob_log.ds_req_logs.event",
          { type: "literal", value: "oob_log.ds_req_logs.event", description: "\"oob_log.ds_req_logs.event\"" },
          "oob_log.ds_req_logs.server_ip",
          { type: "literal", value: "oob_log.ds_req_logs.server_ip", description: "\"oob_log.ds_req_logs.server_ip\"" },
          "oob_log.ds_req_logs.http_version",
          { type: "literal", value: "oob_log.ds_req_logs.http_version", description: "\"oob_log.ds_req_logs.http_version\"" },
          "oob_log.ds_req_logs.method",
          { type: "literal", value: "oob_log.ds_req_logs.method", description: "\"oob_log.ds_req_logs.method\"" },
          "oob_log.ds_req_logs.uri_path",
          { type: "literal", value: "oob_log.ds_req_logs.uri_path", description: "\"oob_log.ds_req_logs.uri_path\"" },
          "oob_log.ds_req_logs.uri_query",
          { type: "literal", value: "oob_log.ds_req_logs.uri_query", description: "\"oob_log.ds_req_logs.uri_query\"" },
          "oob_log.ds_req_logs.pool_name",
          { type: "literal", value: "oob_log.ds_req_logs.pool_name", description: "\"oob_log.ds_req_logs.pool_name\"" },
          "oob_log.ds_req_logs.pool_uuid",
          { type: "literal", value: "oob_log.ds_req_logs.pool_uuid", description: "\"oob_log.ds_req_logs.pool_uuid\"" },
          "oob_log.ds_req_logs.server_name",
          { type: "literal", value: "oob_log.ds_req_logs.server_name", description: "\"oob_log.ds_req_logs.server_name\"" },
          "oob_log.ds_req_logs.headers_sent_to_server",
          { type: "literal", value: "oob_log.ds_req_logs.headers_sent_to_server", description: "\"oob_log.ds_req_logs.headers_sent_to_server\"" },
          "oob_log.ds_req_logs.headers_received_from_server",
          { type: "literal", value: "oob_log.ds_req_logs.headers_received_from_server", description: "\"oob_log.ds_req_logs.headers_received_from_server\"" },
          "ntlm_log.ntlm_status",
          { type: "literal", value: "ntlm_log.ntlm_status", description: "\"ntlm_log.ntlm_status\"" },
          "bot_management_log.classification.type",
          { type: "literal", value: "bot_management_log.classification.type", description: "\"bot_management_log.classification.type\"" },
          "bot_management_log.results.component",
          { type: "literal", value: "bot_management_log.results.component", description: "\"bot_management_log.results.component\"" },
          "bot_management_log.results.identification.class",
          { type: "literal", value: "bot_management_log.results.identification.class", description: "\"bot_management_log.results.identification.class\"" },
          "bot_management_log.results.identification.type",
          { type: "literal", value: "bot_management_log.results.identification.type", description: "\"bot_management_log.results.identification.type\"" },
          "bot_management_log.results.identification.identifier",
          { type: "literal", value: "bot_management_log.results.identification.identifier", description: "\"bot_management_log.results.identification.identifier\"" },
          "bot_management_log.results.confidence",
          { type: "literal", value: "bot_management_log.results.confidence", description: "\"bot_management_log.results.confidence\"" },
          "oauth_log.state",
          { type: "literal", value: "oauth_log.state", description: "\"oauth_log.state\"" },
          "oauth_log.authz_rule_match.rule_name",
          { type: "literal", value: "oauth_log.authz_rule_match.rule_name", description: "\"oauth_log.authz_rule_match.rule_name\"" },
          "oauth_log.authz_rule_match.rule_action",
          { type: "literal", value: "oauth_log.authz_rule_match.rule_action", description: "\"oauth_log.authz_rule_match.rule_action\"" },
          "oauth_log.authn_rule_match.rule_name",
          { type: "literal", value: "oauth_log.authn_rule_match.rule_name", description: "\"oauth_log.authn_rule_match.rule_name\"" },
          "oauth_log.authn_rule_match.rule_action",
          { type: "literal", value: "oauth_log.authn_rule_match.rule_action", description: "\"oauth_log.authn_rule_match.rule_action\"" },
          "oauth_log.jwks_subrequest.error_code",
          { type: "literal", value: "oauth_log.jwks_subrequest.error_code", description: "\"oauth_log.jwks_subrequest.error_code\"" },
          "oauth_log.jwks_subrequest.sub_request_log.pool_name",
          { type: "literal", value: "oauth_log.jwks_subrequest.sub_request_log.pool_name", description: "\"oauth_log.jwks_subrequest.sub_request_log.pool_name\"" },
          "oauth_log.jwks_subrequest.sub_request_log.server_ip",
          { type: "literal", value: "oauth_log.jwks_subrequest.sub_request_log.server_ip", description: "\"oauth_log.jwks_subrequest.sub_request_log.server_ip\"" },
          "oauth_log.jwks_subrequest.sub_request_log.server_name",
          { type: "literal", value: "oauth_log.jwks_subrequest.sub_request_log.server_name", description: "\"oauth_log.jwks_subrequest.sub_request_log.server_name\"" },
          "oauth_log.token_exchange_subrequest.error_code",
          { type: "literal", value: "oauth_log.token_exchange_subrequest.error_code", description: "\"oauth_log.token_exchange_subrequest.error_code\"" },
          "oauth_log.token_exchange_subrequest.sub_request_log.pool_name",
          { type: "literal", value: "oauth_log.token_exchange_subrequest.sub_request_log.pool_name", description: "\"oauth_log.token_exchange_subrequest.sub_request_log.pool_name\"" },
          "oauth_log.token_exchange_subrequest.sub_request_log.server_ip",
          { type: "literal", value: "oauth_log.token_exchange_subrequest.sub_request_log.server_ip", description: "\"oauth_log.token_exchange_subrequest.sub_request_log.server_ip\"" },
          "oauth_log.token_exchange_subrequest.sub_request_log.server_name",
          { type: "literal", value: "oauth_log.token_exchange_subrequest.sub_request_log.server_name", description: "\"oauth_log.token_exchange_subrequest.sub_request_log.server_name\"" },
          "oauth_log.token_introspection_subrequest.error_code",
          { type: "literal", value: "oauth_log.token_introspection_subrequest.error_code", description: "\"oauth_log.token_introspection_subrequest.error_code\"" },
          "oauth_log.token_introspection_subrequest.sub_request_log.pool_name",
          { type: "literal", value: "oauth_log.token_introspection_subrequest.sub_request_log.pool_name", description: "\"oauth_log.token_introspection_subrequest.sub_request_log.pool_name\"" },
          "oauth_log.token_introspection_subrequest.sub_request_log.server_ip",
          { type: "literal", value: "oauth_log.token_introspection_subrequest.sub_request_log.server_ip", description: "\"oauth_log.token_introspection_subrequest.sub_request_log.server_ip\"" },
          "oauth_log.token_introspection_subrequest.sub_request_log.server_name",
          { type: "literal", value: "oauth_log.token_introspection_subrequest.sub_request_log.server_name", description: "\"oauth_log.token_introspection_subrequest.sub_request_log.server_name\"" },
          "oauth_log.token_refresh_subrequest.error_code",
          { type: "literal", value: "oauth_log.token_refresh_subrequest.error_code", description: "\"oauth_log.token_refresh_subrequest.error_code\"" },
          "oauth_log.token_refresh_subrequest.sub_request_log.pool_name",
          { type: "literal", value: "oauth_log.token_refresh_subrequest.sub_request_log.pool_name", description: "\"oauth_log.token_refresh_subrequest.sub_request_log.pool_name\"" },
          "oauth_log.token_refresh_subrequest.sub_request_log.server_ip",
          { type: "literal", value: "oauth_log.token_refresh_subrequest.sub_request_log.server_ip", description: "\"oauth_log.token_refresh_subrequest.sub_request_log.server_ip\"" },
          "oauth_log.token_refresh_subrequest.sub_request_log.server_name",
          { type: "literal", value: "oauth_log.token_refresh_subrequest.sub_request_log.server_name", description: "\"oauth_log.token_refresh_subrequest.sub_request_log.server_name\"" },
          "oauth_log.userinfo_subrequest.error_code",
          { type: "literal", value: "oauth_log.userinfo_subrequest.error_code", description: "\"oauth_log.userinfo_subrequest.error_code\"" },
          "oauth_log.userinfo_subrequest.sub_request_log.pool_name",
          { type: "literal", value: "oauth_log.userinfo_subrequest.sub_request_log.pool_name", description: "\"oauth_log.userinfo_subrequest.sub_request_log.pool_name\"" },
          "oauth_log.userinfo_subrequest.sub_request_log.server_ip",
          { type: "literal", value: "oauth_log.userinfo_subrequest.sub_request_log.server_ip", description: "\"oauth_log.userinfo_subrequest.sub_request_log.server_ip\"" },
          "oauth_log.userinfo_subrequest.sub_request_log.server_name",
          { type: "literal", value: "oauth_log.userinfo_subrequest.sub_request_log.server_name", description: "\"oauth_log.userinfo_subrequest.sub_request_log.server_name\"" },
          "saml_log.saml_auth_status",
          { type: "literal", value: "saml_log.saml_auth_status", description: "\"saml_log.saml_auth_status\"" },
          "saml_log.userid",
          { type: "literal", value: "saml_log.userid", description: "\"saml_log.userid\"" },
          "saml_log.saml_authz_rule_match.saml_authz_matched_rule_name",
          { type: "literal", value: "saml_log.saml_authz_rule_match.saml_authz_matched_rule_name", description: "\"saml_log.saml_authz_rule_match.saml_authz_matched_rule_name\"" },
          "saml_log.saml_authz_rule_match.saml_authz_matched_rule_action",
          { type: "literal", value: "saml_log.saml_authz_rule_match.saml_authz_matched_rule_action", description: "\"saml_log.saml_authz_rule_match.saml_authz_matched_rule_action\"" },
          "saml_log.saml_authn_rule_match.saml_authn_matched_rule_name",
          { type: "literal", value: "saml_log.saml_authn_rule_match.saml_authn_matched_rule_name", description: "\"saml_log.saml_authn_rule_match.saml_authn_matched_rule_name\"" },
          "saml_log.saml_authn_rule_match.saml_authn_matched_rule_action",
          { type: "literal", value: "saml_log.saml_authn_rule_match.saml_authn_matched_rule_action", description: "\"saml_log.saml_authn_rule_match.saml_authn_matched_rule_action\"" },
          "saml_log.saml_attribute_lists.attr_name",
          { type: "literal", value: "saml_log.saml_attribute_lists.attr_name", description: "\"saml_log.saml_attribute_lists.attr_name\"" },
          "paa_log.request_logs.server_name",
          { type: "literal", value: "paa_log.request_logs.server_name", description: "\"paa_log.request_logs.server_name\"" },
          "grpc_service_name",
          { type: "literal", value: "grpc_service_name", description: "\"grpc_service_name\"" },
          "grpc_method_name",
          { type: "literal", value: "grpc_method_name", description: "\"grpc_method_name\"" },
          "grpc_status_reason_phrase",
          { type: "literal", value: "grpc_status_reason_phrase", description: "\"grpc_status_reason_phrase\"" },
          "compression",
          { type: "literal", value: "compression", description: "\"compression\"" },
          "client_fingerprints.filtered_tls_fingerprint",
          { type: "literal", value: "client_fingerprints.filtered_tls_fingerprint", description: "\"client_fingerprints.filtered_tls_fingerprint\"" },
          "client_fingerprints.full_tls_fingerprint",
          { type: "literal", value: "client_fingerprints.full_tls_fingerprint", description: "\"client_fingerprints.full_tls_fingerprint\"" },
          "client_cipher_list.identified_ciphers",
          { type: "literal", value: "client_cipher_list.identified_ciphers", description: "\"client_cipher_list.identified_ciphers\"" },
          "waf_log.allowlist_logs.actions",
          { type: "literal", value: "waf_log.allowlist_logs.actions", description: "\"waf_log.allowlist_logs.actions\"" },
          "waf_log.allowlist_logs.rule_name",
          { type: "literal", value: "waf_log.allowlist_logs.rule_name", description: "\"waf_log.allowlist_logs.rule_name\"" },
          "waf_log.psm_logs.matches.match_element",
          { type: "literal", value: "waf_log.psm_logs.matches.match_element", description: "\"waf_log.psm_logs.matches.match_element\"" },
          "waf_log.psm_logs.matches.match_value",
          { type: "literal", value: "waf_log.psm_logs.matches.match_value", description: "\"waf_log.psm_logs.matches.match_value\"" },
          "waf_log.psm_logs.group_name",
          { type: "literal", value: "waf_log.psm_logs.group_name", description: "\"waf_log.psm_logs.group_name\"" },
          "waf_log.psm_logs.actions",
          { type: "literal", value: "waf_log.psm_logs.actions", description: "\"waf_log.psm_logs.actions\"" },
          "waf_log.psm_logs.location",
          { type: "literal", value: "waf_log.psm_logs.location", description: "\"waf_log.psm_logs.location\"" },
          "waf_log.psm_logs.rule_name",
          { type: "literal", value: "waf_log.psm_logs.rule_name", description: "\"waf_log.psm_logs.rule_name\"" },
          "waf_log.rule_logs.matches.match_value",
          { type: "literal", value: "waf_log.rule_logs.matches.match_value", description: "\"waf_log.rule_logs.matches.match_value\"" },
          "waf_log.rule_logs.msg",
          { type: "literal", value: "waf_log.rule_logs.msg", description: "\"waf_log.rule_logs.msg\"" },
          "waf_log.rule_logs.phase",
          { type: "literal", value: "waf_log.rule_logs.phase", description: "\"waf_log.rule_logs.phase\"" },
          "jwt_log.token_payload",
          { type: "literal", value: "jwt_log.token_payload", description: "\"jwt_log.token_payload\"" },
          "jwt_log.authz_rule_match.rule_name",
          { type: "literal", value: "jwt_log.authz_rule_match.rule_name", description: "\"jwt_log.authz_rule_match.rule_name\"" },
          "jwt_log.authz_rule_match.rule_action",
          { type: "literal", value: "jwt_log.authz_rule_match.rule_action", description: "\"jwt_log.authz_rule_match.rule_action\"" },
          "jwt_log.authn_rule_match.rule_name",
          { type: "literal", value: "jwt_log.authn_rule_match.rule_name", description: "\"jwt_log.authn_rule_match.rule_name\"" },
          "jwt_log.authn_rule_match.rule_action",
          { type: "literal", value: "jwt_log.authn_rule_match.rule_action", description: "\"jwt_log.authn_rule_match.rule_action\"" },
          "vh_match_rule",
          { type: "literal", value: "vh_match_rule", description: "\"vh_match_rule\"" },
          function(variable) {
              return setLastVariable(variable, 'string');
            },
          "persistence_used",
          { type: "literal", value: "persistence_used", description: "\"persistence_used\"" },
          "paa_log.client_request_body_sent",
          { type: "literal", value: "paa_log.client_request_body_sent", description: "\"paa_log.client_request_body_sent\"" },
          "icap_log.request_logs.complete_body_sent",
          { type: "literal", value: "icap_log.request_logs.complete_body_sent", description: "\"icap_log.request_logs.complete_body_sent\"" },
          "cache_hit",
          { type: "literal", value: "cache_hit", description: "\"cache_hit\"" },
          "ntlm_log.ntlm_detected",
          { type: "literal", value: "ntlm_log.ntlm_detected", description: "\"ntlm_log.ntlm_detected\"" },
          "oauth_log.is_session_cookie_expired",
          { type: "literal", value: "oauth_log.is_session_cookie_expired", description: "\"oauth_log.is_session_cookie_expired\"" },
          "saml_log.saml_session_cookie_expired",
          { type: "literal", value: "saml_log.saml_session_cookie_expired", description: "\"saml_log.saml_session_cookie_expired\"" },
          "paa_log.cache_hit",
          { type: "literal", value: "paa_log.cache_hit", description: "\"paa_log.cache_hit\"" },
          "server_push_initiated",
          { type: "literal", value: "server_push_initiated", description: "\"server_push_initiated\"" },
          "server_pushed_request",
          { type: "literal", value: "server_pushed_request", description: "\"server_pushed_request\"" },
          "jwt_log.is_jwt_verified",
          { type: "literal", value: "jwt_log.is_jwt_verified", description: "\"jwt_log.is_jwt_verified\"" },
          "=",
          { type: "literal", value: "=", description: "\"=\"" },
          "!=",
          { type: "literal", value: "!=", description: "\"!=\"" },
          "~=",
          { type: "literal", value: "~=", description: "\"~=\"" },
          "!~=",
          { type: "literal", value: "!~=", description: "\"!~=\"" },
          "^=",
          { type: "literal", value: "^=", description: "\"^=\"" },
          function(literal) {
              return setLastOp(literal, 'string');
            },
          ">=",
          { type: "literal", value: ">=", description: "\">=\"" },
          ">",
          { type: "literal", value: ">", description: "\">\"" },
          "<=",
          { type: "literal", value: "<=", description: "\"<=\"" },
          "<",
          { type: "literal", value: "<", description: "\"<\"" },
          function(literal) {
              return setLastOp(literal, 'number');
            },
          function(literal) {
              return setLastOp(literal, 'bool');
            },
          function(field, op, arr) {
              return finishArr(field, op, arr);
            },
          function(field, op, query) {
              return finishExpr(field, op, query, 'single');
            },
          function(field, op, query) {
              return finishExpr(field, op, query, 'double');
            },
          function(field, op, query) {
              return finishExpr(field, op, query);
            },
          function(query) {
              return finishWildcard(query);
            },
          function(query) {
              return finishEventWildcard(query);
            },
          "l4: ",
          { type: "literal", value: "l4: ", description: "\"l4: \"" },
          function() { start(); },
          function(first) {
              return finishExprList(first, []);
            },
          "l7: ",
          { type: "literal", value: "l7: ", description: "\"l7: \"" },
          "l4_all: ",
          { type: "literal", value: "l4_all: ", description: "\"l4_all: \"" },
          function(first, rest) {
              return finishExprList(first, rest);
            },
          "l7_all: ",
          { type: "literal", value: "l7_all: ", description: "\"l7_all: \"" },
          "event_all: ",
          { type: "literal", value: "event_all: ", description: "\"event_all: \"" }
        ],

        peg$bytecode = [
          peg$decode("7L*5 \"7P*/ \"7N*) \"7R*# \"7T"),
          peg$decode(". \"\"2 3!"),
          peg$decode(".\"\"\"2\"3#"),
          peg$decode(" $0&\"\"1!3'+,$,)&0&\"\"1!3'\"\"\" %"),
          peg$decode("0(\"\"1!3)"),
          peg$decode("0*\"\"1!3+"),
          peg$decode("7$*; \"7%*5 \". \"\"2 3!*) \".\"\"\"2\"3#"),
          peg$decode("7$*; \"7%*5 \".\"\"\"2\"3#*) \".,\"\"2,3-"),
          peg$decode("7$*; \"7%*5 \". \"\"2 3!*) \".,\"\"2,3-"),
          peg$decode("! $7&+&$,#&7&\"\"\" %+' 4!6.!! %"),
          peg$decode("!. \"\"2 3!+J$ $7',#&7'\"+8%. \"\"2 3!+(%4#6.#!!%$## %$\"# %\"# %"),
          peg$decode("!.\"\"\"2\"3#+J$ $7(,#&7(\"+8%.\"\"\"2\"3#+(%4#6.#!!%$## %$\"# %\"# %"),
          peg$decode("!!.\"\"\"2\"3#+E$ $7(,#&7(\"+3%.\"\"\"2\"3#+#%'#%$## %$\"# %\"# %*V \"!. \"\"2 3!+E$ $7',#&7'\"+3%. \"\"2 3!+#%'#%$## %$\"# %\"# %+! (%"),
          peg$decode("7)*) \"7**# \"7+"),
          peg$decode("!.0\"\"2031*# \" /+\x95$ $02\"\"1!33+,$,)&02\"\"1!33\"\"\" %+p%!.4\"\"2435+H$ $02\"\"1!33+,$,)&02\"\"1!33\"\"\" %+#%'\"%$\"# %\"# %*# \" /+*%4#66##\"! %$## %$\"# %\"# %*A \".7\"\"2738*5 \".9\"\"293:*) \".;\"\"2;3<"),
          peg$decode(".=\"\"2=3>*\xC5 \".?\"\"2?3@*\xB9 \".A\"\"2A3B*\xAD \".C\"\"2C3D*\xA1 \".E\"\"2E3F*\x95 \".G\"\"2G3H*\x89 \".I\"\"2I3J*} \".K\"\"2K3L*q \".M\"\"2M3N*e \".O\"\"2O3P*Y \".Q\"\"2Q3R*M \".S\"\"2S3T*A \".7\"\"2738*5 \".9\"\"293:*) \".;\"\"2;3<"),
          peg$decode("!.U\"\"2U3V+J$ $7#,#&7#\"+8%7,*# \" /+(%4#6W#! %$## %$\"# %\"# %"),
          peg$decode("!0X\"\"1!3Y+U$7,+K% $70,#&70\"+9%0Z\"\"1!3[+)%4$6\\$\"\"!%$$# %$## %$\"# %\"# %"),
          peg$decode(".]\"\"2]3^*M \"._\"\"2_3`*A \".a\"\"2a3b*5 \".c\"\"2c3d*) \".e\"\"2e3f"),
          peg$decode(".g\"\"2g3h*\u0239 \".i\"\"2i3j*\u022D \".k\"\"2k3l*\u0221 \".m\"\"2m3n*\u0215 \".o\"\"2o3p*\u0209 \".q\"\"2q3r*\u01FD \".s\"\"2s3t*\u01F1 \".u\"\"2u3v*\u01E5 \".w\"\"2w3x*\u01D9 \".y\"\"2y3z*\u01CD \".{\"\"2{3|*\u01C1 \".}\"\"2}3~*\u01B5 \".\"\"23\x80*\u01A9 \".\x81\"\"2\x813\x82*\u019D \".\x83\"\"2\x833\x84*\u0191 \".\x85\"\"2\x853\x86*\u0185 \".\x87\"\"2\x873\x88*\u0179 \".\x89\"\"2\x893\x8A*\u016D \".\x8B\"\"2\x8B3\x8C*\u0161 \".\x8D\"\"2\x8D3\x8E*\u0155 \".\x8F\"\"2\x8F3\x90*\u0149 \".\x91\"\"2\x913\x92*\u013D \".\x93\"\"2\x933\x94*\u0131 \".\x95\"\"2\x953\x96*\u0125 \".\x97\"\"2\x973\x98*\u0119 \".\x99\"\"2\x993\x9A*\u010D \".\x9B\"\"2\x9B3\x9C*\u0101 \".\x9D\"\"2\x9D3\x9E*\xF5 \".\x9F\"\"2\x9F3\xA0*\xE9 \".\xA1\"\"2\xA13\xA2*\xDD \".\xA3\"\"2\xA33\xA4*\xD1 \".\xA5\"\"2\xA53\xA6*\xC5 \".\xA7\"\"2\xA73\xA8*\xB9 \".\xA9\"\"2\xA93\xAA*\xAD \".\xAB\"\"2\xAB3\xAC*\xA1 \".\xAD\"\"2\xAD3\xAE*\x95 \".\xAF\"\"2\xAF3\xB0*\x89 \".\xB1\"\"2\xB13\xB2*} \".\xB3\"\"2\xB33\xB4*q \".\xB5\"\"2\xB53\xB6*e \".\xB7\"\"2\xB73\xB8*Y \".\xB9\"\"2\xB93\xBA*M \".\xBB\"\"2\xBB3\xBC*A \".\xBD\"\"2\xBD3\xBE*5 \".\xBF\"\"2\xBF3\xC0*) \".\xC1\"\"2\xC13\xC2"),
          peg$decode("!73+' 4!6\xC3!! %"),
          peg$decode(".\xC4\"\"2\xC43\xC5*\u0245 \".\xC6\"\"2\xC63\xC7*\u0239 \".\xC8\"\"2\xC83\xC9*\u022D \".\xCA\"\"2\xCA3\xCB*\u0221 \".\xCC\"\"2\xCC3\xCD*\u0215 \".\xCE\"\"2\xCE3\xCF*\u0209 \".\xD0\"\"2\xD03\xD1*\u01FD \".\xD2\"\"2\xD23\xD3*\u01F1 \".\xD4\"\"2\xD43\xD5*\u01E5 \".\xD6\"\"2\xD63\xD7*\u01D9 \".\xD8\"\"2\xD83\xD9*\u01CD \".\xDA\"\"2\xDA3\xDB*\u01C1 \".\xDC\"\"2\xDC3\xDD*\u01B5 \".\xDE\"\"2\xDE3\xDF*\u01A9 \".\xE0\"\"2\xE03\xE1*\u019D \".\xE2\"\"2\xE23\xE3*\u0191 \".\xE4\"\"2\xE43\xE5*\u0185 \".\xE6\"\"2\xE63\xE7*\u0179 \".\xE8\"\"2\xE83\xE9*\u016D \".\xEA\"\"2\xEA3\xEB*\u0161 \".\xEC\"\"2\xEC3\xED*\u0155 \".\xEE\"\"2\xEE3\xEF*\u0149 \".\xF0\"\"2\xF03\xF1*\u013D \".\xF2\"\"2\xF23\xF3*\u0131 \".\xF4\"\"2\xF43\xF5*\u0125 \".\xF6\"\"2\xF63\xF7*\u0119 \".\xF8\"\"2\xF83\xF9*\u010D \".\xFA\"\"2\xFA3\xFB*\u0101 \".\xFC\"\"2\xFC3\xFD*\xF5 \".\xFE\"\"2\xFE3\xFF*\xE9 \".\u0100\"\"2\u01003\u0101*\xDD \".\u0102\"\"2\u01023\u0103*\xD1 \".\u0104\"\"2\u01043\u0105*\xC5 \".\u0106\"\"2\u01063\u0107*\xB9 \".\u0108\"\"2\u01083\u0109*\xAD \".\u010A\"\"2\u010A3\u010B*\xA1 \".\u010C\"\"2\u010C3\u010D*\x95 \".\u010E\"\"2\u010E3\u010F*\x89 \".\u0110\"\"2\u01103\u0111*} \".\u0112\"\"2\u01123\u0113*q \".\u0114\"\"2\u01143\u0115*e \".\u0116\"\"2\u01163\u0117*Y \".\u0118\"\"2\u01183\u0119*M \".\u011A\"\"2\u011A3\u011B*A \".\u011C\"\"2\u011C3\u011D*5 \".\u011E\"\"2\u011E3\u011F*) \".\u0120\"\"2\u01203\u0121"),
          peg$decode("!75+' 4!6\u0122!! %"),
          peg$decode(".\u0123\"\"2\u01233\u0124*\xB9 \".\u0125\"\"2\u01253\u0126*\xAD \".\u0127\"\"2\u01273\u0128*\xA1 \".\u0129\"\"2\u01293\u012A*\x95 \".\u012B\"\"2\u012B3\u012C*\x89 \".\u012D\"\"2\u012D3\u012E*} \".\u012F\"\"2\u012F3\u0130*q \".\u0131\"\"2\u01313\u0132*e \".\u0133\"\"2\u01333\u0134*Y \".\u0135\"\"2\u01353\u0136*M \".\u0137\"\"2\u01373\u0138*A \".\u0139\"\"2\u01393\u013A*5 \".\u013B\"\"2\u013B3\u013C*) \".\u013D\"\"2\u013D3\u013E"),
          peg$decode("!77+' 4!6\u013F!! %"),
          peg$decode(".\x85\"\"2\x853\x86*\u02F9 \".g\"\"2g3h*\u02ED \".i\"\"2i3j*\u02E1 \".\u0140\"\"2\u01403\u0141*\u02D5 \".\u0142\"\"2\u01423\u0143*\u02C9 \".\x87\"\"2\x873\x88*\u02BD \".\x89\"\"2\x893\x8A*\u02B1 \".\x8B\"\"2\x8B3\x8C*\u02A5 \".\u0144\"\"2\u01443\u0145*\u0299 \".\u0146\"\"2\u01463\u0147*\u028D \".\u0148\"\"2\u01483\u0149*\u0281 \".k\"\"2k3l*\u0275 \".\u014A\"\"2\u014A3\u014B*\u0269 \".\u014C\"\"2\u014C3\u014D*\u025D \".\u014E\"\"2\u014E3\u014F*\u0251 \".\u0150\"\"2\u01503\u0151*\u0245 \".\u0152\"\"2\u01523\u0153*\u0239 \".\u0154\"\"2\u01543\u0155*\u022D \".\u0156\"\"2\u01563\u0157*\u0221 \".\u0158\"\"2\u01583\u0159*\u0215 \".\u015A\"\"2\u015A3\u015B*\u0209 \".\u015C\"\"2\u015C3\u015D*\u01FD \".\u015E\"\"2\u015E3\u015F*\u01F1 \".\u0160\"\"2\u01603\u0161*\u01E5 \".\u0162\"\"2\u01623\u0163*\u01D9 \".\u0164\"\"2\u01643\u0165*\u01CD \".\u0166\"\"2\u01663\u0167*\u01C1 \".\u0168\"\"2\u01683\u0169*\u01B5 \".\u016A\"\"2\u016A3\u016B*\u01A9 \".\u016C\"\"2\u016C3\u016D*\u019D \".\u016E\"\"2\u016E3\u016F*\u0191 \".\u0170\"\"2\u01703\u0171*\u0185 \".\u0172\"\"2\u01723\u0173*\u0179 \".\u0174\"\"2\u01743\u0175*\u016D \".\u0176\"\"2\u01763\u0177*\u0161 \".\u0178\"\"2\u01783\u0179*\u0155 \".\u017A\"\"2\u017A3\u017B*\u0149 \".\u017C\"\"2\u017C3\u017D*\u013D \".\u017E\"\"2\u017E3\u017F*\u0131 \".\u0180\"\"2\u01803\u0181*\u0125 \".\u0182\"\"2\u01823\u0183*\u0119 \".\u0184\"\"2\u01843\u0185*\u010D \".\u0186\"\"2\u01863\u0187*\u0101 \".\u0188\"\"2\u01883\u0189*\xF5 \".\u018A\"\"2\u018A3\u018B*\xE9 \".\u018C\"\"2\u018C3\u018D*\xDD \".\u018E\"\"2\u018E3\u018F*\xD1 \".\u0190\"\"2\u01903\u0191*\xC5 \".\u0192\"\"2\u01923\u0193*\xB9 \".\u0194\"\"2\u01943\u0195*\xAD \".\u0196\"\"2\u01963\u0197*\xA1 \".\u0198\"\"2\u01983\u0199*\x95 \".\u019A\"\"2\u019A3\u019B*\x89 \".\u019C\"\"2\u019C3\u019D*} \".\u019E\"\"2\u019E3\u019F*q \".\u01A0\"\"2\u01A03\u01A1*e \".\u01A2\"\"2\u01A23\u01A3*Y \".\u01A4\"\"2\u01A43\u01A5*M \".\u01A6\"\"2\u01A63\u01A7*A \".\u01A8\"\"2\u01A83\u01A9*5 \".\u01AA\"\"2\u01AA3\u01AB*) \".\u01AC\"\"2\u01AC3\u01AD"),
          peg$decode("!79+' 4!6\xC3!! %"),
          peg$decode(".\xC4\"\"2\xC43\xC5*\u0761 \".\xC6\"\"2\xC63\xC7*\u0755 \".\u01AE\"\"2\u01AE3\u01AF*\u0749 \".\xC8\"\"2\xC83\xC9*\u073D \".\xCA\"\"2\xCA3\xCB*\u0731 \".\u01B0\"\"2\u01B03\u01B1*\u0725 \".\xCC\"\"2\xCC3\xCD*\u0719 \".\xD6\"\"2\xD63\xD7*\u070D \".\xCE\"\"2\xCE3\xCF*\u0701 \".\xF6\"\"2\xF63\xF7*\u06F5 \".\xF8\"\"2\xF83\xF9*\u06E9 \".\xFA\"\"2\xFA3\xFB*\u06DD \".\u01B2\"\"2\u01B23\u01B3*\u06D1 \".\u01B4\"\"2\u01B43\u01B5*\u06C5 \".\u01B6\"\"2\u01B63\u01B7*\u06B9 \".\u01B8\"\"2\u01B83\u01B9*\u06AD \".\u01BA\"\"2\u01BA3\u01BB*\u06A1 \".\u01BC\"\"2\u01BC3\u01BD*\u0695 \".\u01BE\"\"2\u01BE3\u01BF*\u0689 \".\u01C0\"\"2\u01C03\u01C1*\u067D \".\u01C2\"\"2\u01C23\u01C3*\u0671 \".\u01C4\"\"2\u01C43\u01C5*\u0665 \".\u01C6\"\"2\u01C63\u01C7*\u0659 \".\u01C8\"\"2\u01C83\u01C9*\u064D \".\u01CA\"\"2\u01CA3\u01CB*\u0641 \".\u01CC\"\"2\u01CC3\u01CD*\u0635 \".\u01CE\"\"2\u01CE3\u01CF*\u0629 \".\xD8\"\"2\xD83\xD9*\u061D \".\u01D0\"\"2\u01D03\u01D1*\u0611 \".\u01D2\"\"2\u01D23\u01D3*\u0605 \".\xDA\"\"2\xDA3\xDB*\u05F9 \".\xDC\"\"2\xDC3\xDD*\u05ED \".\xDE\"\"2\xDE3\xDF*\u05E1 \".\xD0\"\"2\xD03\xD1*\u05D5 \".\xD2\"\"2\xD23\xD3*\u05C9 \".\xD4\"\"2\xD43\xD5*\u05BD \".\u01D4\"\"2\u01D43\u01D5*\u05B1 \".\u01D6\"\"2\u01D63\u01D7*\u05A5 \".\u01D8\"\"2\u01D83\u01D9*\u0599 \".\u01DA\"\"2\u01DA3\u01DB*\u058D \".\u01DC\"\"2\u01DC3\u01DD*\u0581 \".\u01DE\"\"2\u01DE3\u01DF*\u0575 \".\u01E0\"\"2\u01E03\u01E1*\u0569 \".\u01E2\"\"2\u01E23\u01E3*\u055D \".\u01E4\"\"2\u01E43\u01E5*\u0551 \".\xE0\"\"2\xE03\xE1*\u0545 \".\xE2\"\"2\xE23\xE3*\u0539 \".\xF2\"\"2\xF23\xF3*\u052D \".\u01E6\"\"2\u01E63\u01E7*\u0521 \".\u01E8\"\"2\u01E83\u01E9*\u0515 \".\u01EA\"\"2\u01EA3\u01EB*\u0509 \".\u01EC\"\"2\u01EC3\u01ED*\u04FD \".\u01EE\"\"2\u01EE3\u01EF*\u04F1 \".\u01F0\"\"2\u01F03\u01F1*\u04E5 \".\u01F2\"\"2\u01F23\u01F3*\u04D9 \".\u01F4\"\"2\u01F43\u01F5*\u04CD \".\u01F6\"\"2\u01F63\u01F7*\u04C1 \".\u01F8\"\"2\u01F83\u01F9*\u04B5 \".\u01FA\"\"2\u01FA3\u01FB*\u04A9 \".\u01FC\"\"2\u01FC3\u01FD*\u049D \".\u01FE\"\"2\u01FE3\u01FF*\u0491 \".\u0200\"\"2\u02003\u0201*\u0485 \".\u0202\"\"2\u02023\u0203*\u0479 \".\u0204\"\"2\u02043\u0205*\u046D \".\u0206\"\"2\u02063\u0207*\u0461 \".\u0208\"\"2\u02083\u0209*\u0455 \".\u020A\"\"2\u020A3\u020B*\u0449 \".\u020C\"\"2\u020C3\u020D*\u043D \".\u020E\"\"2\u020E3\u020F*\u0431 \".\u0210\"\"2\u02103\u0211*\u0425 \".\u0212\"\"2\u02123\u0213*\u0419 \".\u0214\"\"2\u02143\u0215*\u040D \".\u0216\"\"2\u02163\u0217*\u0401 \".\u0218\"\"2\u02183\u0219*\u03F5 \".\u021A\"\"2\u021A3\u021B*\u03E9 \".\u021C\"\"2\u021C3\u021D*\u03DD \".\u021E\"\"2\u021E3\u021F*\u03D1 \".\u0220\"\"2\u02203\u0221*\u03C5 \".\u0222\"\"2\u02223\u0223*\u03B9 \".\u0224\"\"2\u02243\u0225*\u03AD \".\u0226\"\"2\u02263\u0227*\u03A1 \".\u0228\"\"2\u02283\u0229*\u0395 \".\u022A\"\"2\u022A3\u022B*\u0389 \".\u022C\"\"2\u022C3\u022D*\u037D \".\u022E\"\"2\u022E3\u022F*\u0371 \".\u0230\"\"2\u02303\u0231*\u0365 \".\u0232\"\"2\u02323\u0233*\u0359 \".\u0234\"\"2\u02343\u0235*\u034D \".\u0236\"\"2\u02363\u0237*\u0341 \".\u0238\"\"2\u02383\u0239*\u0335 \".\u023A\"\"2\u023A3\u023B*\u0329 \".\xF4\"\"2\xF43\xF5*\u031D \".\u023C\"\"2\u023C3\u023D*\u0311 \".\u023E\"\"2\u023E3\u023F*\u0305 \".\u0240\"\"2\u02403\u0241*\u02F9 \".\u0242\"\"2\u02423\u0243*\u02ED \".\u0244\"\"2\u02443\u0245*\u02E1 \".\u0246\"\"2\u02463\u0247*\u02D5 \".\u0248\"\"2\u02483\u0249*\u02C9 \".\u024A\"\"2\u024A3\u024B*\u02BD \".\u024C\"\"2\u024C3\u024D*\u02B1 \".\u024E\"\"2\u024E3\u024F*\u02A5 \".\u0250\"\"2\u02503\u0251*\u0299 \".\u0252\"\"2\u02523\u0253*\u028D \".\u0254\"\"2\u02543\u0255*\u0281 \".\u0256\"\"2\u02563\u0257*\u0275 \".\u0258\"\"2\u02583\u0259*\u0269 \".\u025A\"\"2\u025A3\u025B*\u025D \".\u025C\"\"2\u025C3\u025D*\u0251 \".\u025E\"\"2\u025E3\u025F*\u0245 \".\u0260\"\"2\u02603\u0261*\u0239 \".\u0262\"\"2\u02623\u0263*\u022D \".\u0264\"\"2\u02643\u0265*\u0221 \".\u0266\"\"2\u02663\u0267*\u0215 \".\u0268\"\"2\u02683\u0269*\u0209 \".\u026A\"\"2\u026A3\u026B*\u01FD \".\u026C\"\"2\u026C3\u026D*\u01F1 \".\u026E\"\"2\u026E3\u026F*\u01E5 \".\u0270\"\"2\u02703\u0271*\u01D9 \".\u0272\"\"2\u02723\u0273*\u01CD \".\u0274\"\"2\u02743\u0275*\u01C1 \".\u0276\"\"2\u02763\u0277*\u01B5 \".\u0278\"\"2\u02783\u0279*\u01A9 \".\u027A\"\"2\u027A3\u027B*\u019D \".\u027C\"\"2\u027C3\u027D*\u0191 \".\u027E\"\"2\u027E3\u027F*\u0185 \".\u0280\"\"2\u02803\u0281*\u0179 \".\u0282\"\"2\u02823\u0283*\u016D \".\u0284\"\"2\u02843\u0285*\u0161 \".\u0286\"\"2\u02863\u0287*\u0155 \".\u0288\"\"2\u02883\u0289*\u0149 \".\u028A\"\"2\u028A3\u028B*\u013D \".\u028C\"\"2\u028C3\u028D*\u0131 \".\u028E\"\"2\u028E3\u028F*\u0125 \".\u0290\"\"2\u02903\u0291*\u0119 \".\u0292\"\"2\u02923\u0293*\u010D \".\u0294\"\"2\u02943\u0295*\u0101 \".\u0296\"\"2\u02963\u0297*\xF5 \".\u0298\"\"2\u02983\u0299*\xE9 \".\u029A\"\"2\u029A3\u029B*\xDD \".\u029C\"\"2\u029C3\u029D*\xD1 \".\u029E\"\"2\u029E3\u029F*\xC5 \".\u02A0\"\"2\u02A03\u02A1*\xB9 \".\u02A2\"\"2\u02A23\u02A3*\xAD \".\u02A4\"\"2\u02A43\u02A5*\xA1 \".\u02A6\"\"2\u02A63\u02A7*\x95 \".\u02A8\"\"2\u02A83\u02A9*\x89 \".\u02AA\"\"2\u02AA3\u02AB*} \".\u02AC\"\"2\u02AC3\u02AD*q \".\u02AE\"\"2\u02AE3\u02AF*e \".\u02B0\"\"2\u02B03\u02B1*Y \".\u02B2\"\"2\u02B23\u02B3*M \".\u02B4\"\"2\u02B43\u02B5*A \".\u02B6\"\"2\u02B63\u02B7*5 \".\u02B8\"\"2\u02B83\u02B9*) \".\u02BA\"\"2\u02BA3\u02BB"),
          peg$decode("!7;+' 4!6\u02BC!! %"),
          peg$decode(".\u02BD\"\"2\u02BD3\u02BE*\xA1 \".\u02BF\"\"2\u02BF3\u02C0*\x95 \".\u0125\"\"2\u01253\u0126*\x89 \".\u02C1\"\"2\u02C13\u02C2*} \".\u02C3\"\"2\u02C33\u02C4*q \".\u02C5\"\"2\u02C53\u02C6*e \".\u02C7\"\"2\u02C73\u02C8*Y \".\u02C9\"\"2\u02C93\u02CA*M \".\u02CB\"\"2\u02CB3\u02CC*A \".\u02CD\"\"2\u02CD3\u02CE*5 \".\u02CF\"\"2\u02CF3\u02D0*) \".\u02D1\"\"2\u02D13\u02D2"),
          peg$decode("!7=+' 4!6\u013F!! %"),
          peg$decode(".\u02D3\"\"2\u02D33\u02D4*M \".\u02D5\"\"2\u02D53\u02D6*A \".\u02D7\"\"2\u02D73\u02D8*5 \".\u02D9\"\"2\u02D93\u02DA*) \".\u02DB\"\"2\u02DB3\u02DC"),
          peg$decode("!7#*# \" /+B$7?+8%7#*# \" /+(%4#6\u02DD#!!%$## %$\"# %\"# %"),
          peg$decode(".\u02D3\"\"2\u02D33\u02D4*Y \".\u02D5\"\"2\u02D53\u02D6*M \".\u02DE\"\"2\u02DE3\u02DF*A \".\u02E0\"\"2\u02E03\u02E1*5 \".\u02E2\"\"2\u02E23\u02E3*) \".\u02E4\"\"2\u02E43\u02E5"),
          peg$decode("!7#*# \" /+B$7A+8%7#*# \" /+(%4#6\u02E6#!!%$## %$\"# %\"# %"),
          peg$decode(".\u02D3\"\"2\u02D33\u02D4*) \".\u02D5\"\"2\u02D53\u02D6"),
          peg$decode("!7#*# \" /+B$7C+8%7#*# \" /+(%4#6\u02E7#!!%$## %$\"# %\"# %"),
          peg$decode("!76+>$7@+4%71+*%4#6\u02E8##\"! %$## %$\"# %\"# %*\xCD \"!76+>$7@+4%7++*%4#6\u02E9##\"! %$## %$\"# %\"# %*\xA1 \"!76+>$7@+4%7*+*%4#6\u02EA##\"! %$## %$\"# %\"# %*u \"!74+>$7B+4%7.+*%4#6\u02EB##\"! %$## %$\"# %\"# %*I \"!78+>$7D+4%7/+*%4#6\u02EB##\"! %$## %$\"# %\"# %"),
          peg$decode("!7<+>$7@+4%71+*%4#6\u02E8##\"! %$## %$\"# %\"# %*\xCD \"!7<+>$7@+4%7++*%4#6\u02E9##\"! %$## %$\"# %\"# %*\xA1 \"!7<+>$7@+4%7*+*%4#6\u02EA##\"! %$## %$\"# %\"# %*u \"!7:+>$7B+4%7.+*%4#6\u02EB##\"! %$## %$\"# %\"# %*I \"!7>+>$7D+4%7/+*%4#6\u02EB##\"! %$## %$\"# %\"# %"),
          peg$decode("!72+>$7@+4%7)+*%4#6\u02E8##\"! %$## %$\"# %\"# %*u \"!72+>$7@+4%7++*%4#6\u02E9##\"! %$## %$\"# %\"# %*I \"!72+>$7@+4%7*+*%4#6\u02EA##\"! %$## %$\"# %\"# %"),
          peg$decode("7E*/ \"!7-+' 4!6\u02EC!! %"),
          peg$decode("7F*/ \"!7-+' 4!6\u02EC!! %"),
          peg$decode("7G*/ \"!7)+' 4!6\u02ED!! %"),
          peg$decode("!.\u02EE\"\"2\u02EE3\u02EF+& 4!6\u02F0! %"),
          peg$decode("!7K+2$7E+(%4\"6\u02F1\"! %$\"# %\"# %"),
          peg$decode("!.\u02F2\"\"2\u02F23\u02F3+& 4!6\u02F0! %"),
          peg$decode("!7M+2$7F+(%4\"6\u02F1\"! %$\"# %\"# %"),
          peg$decode("!.\u02F4\"\"2\u02F43\u02F5+& 4!6\u02F0! %"),
          peg$decode("!7O+o$7H+e% $!7#+-$7H+#%'\"%$\"# %\"# %,8&!7#+-$7H+#%'\"%$\"# %\"# %\"+)%4#6\u02F6#\"! %$## %$\"# %\"# %"),
          peg$decode("!.\u02F7\"\"2\u02F73\u02F8+& 4!6\u02F0! %"),
          peg$decode("!7Q+o$7I+e% $!7#+-$7I+#%'\"%$\"# %\"# %,8&!7#+-$7I+#%'\"%$\"# %\"# %\"+)%4#6\u02F6#\"! %$## %$\"# %\"# %"),
          peg$decode("!.\u02F9\"\"2\u02F93\u02FA+& 4!6\u02F0! %"),
          peg$decode("!7S+o$7J+e% $!7#+-$7J+#%'\"%$\"# %\"# %,8&!7#+-$7J+#%'\"%$\"# %\"# %\"+)%4#6\u02F6#\"! %$## %$\"# %\"# %")
        ],

        peg$currPos          = 0,
        peg$reportedPos      = 0,
        peg$cachedPos        = 0,
        peg$cachedPosDetails = { line: 1, column: 1, seenCR: false },
        peg$maxFailPos       = 0,
        peg$maxFailExpected  = [],
        peg$silentFails      = 0,

        peg$result;

    if ("startRule" in options) {
      if (!(options.startRule in peg$startRuleIndices)) {
        throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
      }

      peg$startRuleIndex = peg$startRuleIndices[options.startRule];
    }

    function text() {
      return input.substring(peg$reportedPos, peg$currPos);
    }

    function offset() {
      return peg$reportedPos;
    }

    function line() {
      return peg$computePosDetails(peg$reportedPos).line;
    }

    function column() {
      return peg$computePosDetails(peg$reportedPos).column;
    }

    function expected(description) {
      throw peg$buildException(
        null,
        [{ type: "other", description: description }],
        peg$reportedPos
      );
    }

    function error(message) {
      throw peg$buildException(message, null, peg$reportedPos);
    }

    function peg$computePosDetails(pos) {
      function advance(details, startPos, endPos) {
        var p, ch;

        for (p = startPos; p < endPos; p++) {
          ch = input.charAt(p);
          if (ch === "\n") {
            if (!details.seenCR) { details.line++; }
            details.column = 1;
            details.seenCR = false;
          } else if (ch === "\r" || ch === "\u2028" || ch === "\u2029") {
            details.line++;
            details.column = 1;
            details.seenCR = true;
          } else {
            details.column++;
            details.seenCR = false;
          }
        }
      }

      if (peg$cachedPos !== pos) {
        if (peg$cachedPos > pos) {
          peg$cachedPos = 0;
          peg$cachedPosDetails = { line: 1, column: 1, seenCR: false };
        }
        advance(peg$cachedPosDetails, peg$cachedPos, pos);
        peg$cachedPos = pos;
      }

      return peg$cachedPosDetails;
    }

    function peg$fail(expected) {
      if (peg$currPos < peg$maxFailPos) { return; }

      if (peg$currPos > peg$maxFailPos) {
        peg$maxFailPos = peg$currPos;
        peg$maxFailExpected = [];
      }

      peg$maxFailExpected.push(expected);
    }

    function peg$buildException(message, expected, pos) {
      function cleanupExpected(expected) {
        var i = 1;

        expected.sort(function(a, b) {
          if (a.description < b.description) {
            return -1;
          } else if (a.description > b.description) {
            return 1;
          } else {
            return 0;
          }
        });

        while (i < expected.length) {
          if (expected[i - 1] === expected[i]) {
            expected.splice(i, 1);
          } else {
            i++;
          }
        }
      }

      function buildMessage(expected, found) {
        function stringEscape(s) {
          function hex(ch) { return ch.charCodeAt(0).toString(16).toUpperCase(); }

          return s
            .replace(/\\/g,   '\\\\')
            .replace(/"/g,    '\\"')
            .replace(/\x08/g, '\\b')
            .replace(/\t/g,   '\\t')
            .replace(/\n/g,   '\\n')
            .replace(/\f/g,   '\\f')
            .replace(/\r/g,   '\\r')
            .replace(/[\x00-\x07\x0B\x0E\x0F]/g, function(ch) { return '\\x0' + hex(ch); })
            .replace(/[\x10-\x1F\x80-\xFF]/g,    function(ch) { return '\\x'  + hex(ch); })
            .replace(/[\u0180-\u0FFF]/g,         function(ch) { return '\\u0' + hex(ch); })
            .replace(/[\u1080-\uFFFF]/g,         function(ch) { return '\\u'  + hex(ch); });
        }

        var expectedDescs = new Array(expected.length),
            expectedDesc, foundDesc, i;

        for (i = 0; i < expected.length; i++) {
          expectedDescs[i] = expected[i].description;
        }

        expectedDesc = expected.length > 1
          ? expectedDescs.slice(0, -1).join(", ")
              + " or "
              + expectedDescs[expected.length - 1]
          : expectedDescs[0];

        foundDesc = found ? "\"" + stringEscape(found) + "\"" : "end of input";

        return "Expected " + expectedDesc + " but " + foundDesc + " found.";
      }

      var posDetails = peg$computePosDetails(pos),
          found      = pos < input.length ? input.charAt(pos) : null;

      if (expected !== null) {
        cleanupExpected(expected);
      }

      return new SyntaxError(
        message !== null ? message : buildMessage(expected, found),
        expected,
        found,
        pos,
        posDetails.line,
        posDetails.column
      );
    }

    function peg$decode(s) {
      var bc = new Array(s.length), i;

      for (i = 0; i < s.length; i++) {
        bc[i] = s.charCodeAt(i) - 32;
      }

      return bc;
    }

    function peg$parseRule(index) {
      var bc    = peg$bytecode[index],
          ip    = 0,
          ips   = [],
          end   = bc.length,
          ends  = [],
          stack = [],
          params, i;

      function protect(object) {
        return Object.prototype.toString.apply(object) === "[object Array]" ? [] : object;
      }

      while (true) {
        while (ip < end) {
          switch (bc[ip]) {
            case 0:
              stack.push(protect(peg$consts[bc[ip + 1]]));
              ip += 2;
              break;

            case 1:
              stack.push(peg$currPos);
              ip++;
              break;

            case 2:
              stack.pop();
              ip++;
              break;

            case 3:
              peg$currPos = stack.pop();
              ip++;
              break;

            case 4:
              stack.length -= bc[ip + 1];
              ip += 2;
              break;

            case 5:
              stack.splice(-2, 1);
              ip++;
              break;

            case 6:
              stack[stack.length - 2].push(stack.pop());
              ip++;
              break;

            case 7:
              stack.push(stack.splice(stack.length - bc[ip + 1], bc[ip + 1]));
              ip += 2;
              break;

            case 8:
              stack.pop();
              stack.push(input.substring(stack[stack.length - 1], peg$currPos));
              ip++;
              break;

            case 9:
              ends.push(end);
              ips.push(ip + 3 + bc[ip + 1] + bc[ip + 2]);

              if (stack[stack.length - 1]) {
                end = ip + 3 + bc[ip + 1];
                ip += 3;
              } else {
                end = ip + 3 + bc[ip + 1] + bc[ip + 2];
                ip += 3 + bc[ip + 1];
              }

              break;

            case 10:
              ends.push(end);
              ips.push(ip + 3 + bc[ip + 1] + bc[ip + 2]);

              if (stack[stack.length - 1] === peg$FAILED) {
                end = ip + 3 + bc[ip + 1];
                ip += 3;
              } else {
                end = ip + 3 + bc[ip + 1] + bc[ip + 2];
                ip += 3 + bc[ip + 1];
              }

              break;

            case 11:
              ends.push(end);
              ips.push(ip + 3 + bc[ip + 1] + bc[ip + 2]);

              if (stack[stack.length - 1] !== peg$FAILED) {
                end = ip + 3 + bc[ip + 1];
                ip += 3;
              } else {
                end = ip + 3 + bc[ip + 1] + bc[ip + 2];
                ip += 3 + bc[ip + 1];
              }

              break;

            case 12:
              if (stack[stack.length - 1] !== peg$FAILED) {
                ends.push(end);
                ips.push(ip);

                end = ip + 2 + bc[ip + 1];
                ip += 2;
              } else {
                ip += 2 + bc[ip + 1];
              }

              break;

            case 13:
              ends.push(end);
              ips.push(ip + 3 + bc[ip + 1] + bc[ip + 2]);

              if (input.length > peg$currPos) {
                end = ip + 3 + bc[ip + 1];
                ip += 3;
              } else {
                end = ip + 3 + bc[ip + 1] + bc[ip + 2];
                ip += 3 + bc[ip + 1];
              }

              break;

            case 14:
              ends.push(end);
              ips.push(ip + 4 + bc[ip + 2] + bc[ip + 3]);

              if (input.substr(peg$currPos, peg$consts[bc[ip + 1]].length) === peg$consts[bc[ip + 1]]) {
                end = ip + 4 + bc[ip + 2];
                ip += 4;
              } else {
                end = ip + 4 + bc[ip + 2] + bc[ip + 3];
                ip += 4 + bc[ip + 2];
              }

              break;

            case 15:
              ends.push(end);
              ips.push(ip + 4 + bc[ip + 2] + bc[ip + 3]);

              if (input.substr(peg$currPos, peg$consts[bc[ip + 1]].length).toLowerCase() === peg$consts[bc[ip + 1]]) {
                end = ip + 4 + bc[ip + 2];
                ip += 4;
              } else {
                end = ip + 4 + bc[ip + 2] + bc[ip + 3];
                ip += 4 + bc[ip + 2];
              }

              break;

            case 16:
              ends.push(end);
              ips.push(ip + 4 + bc[ip + 2] + bc[ip + 3]);

              if (peg$consts[bc[ip + 1]].test(input.charAt(peg$currPos))) {
                end = ip + 4 + bc[ip + 2];
                ip += 4;
              } else {
                end = ip + 4 + bc[ip + 2] + bc[ip + 3];
                ip += 4 + bc[ip + 2];
              }

              break;

            case 17:
              stack.push(input.substr(peg$currPos, bc[ip + 1]));
              peg$currPos += bc[ip + 1];
              ip += 2;
              break;

            case 18:
              stack.push(peg$consts[bc[ip + 1]]);
              peg$currPos += peg$consts[bc[ip + 1]].length;
              ip += 2;
              break;

            case 19:
              stack.push(peg$FAILED);
              if (peg$silentFails === 0) {
                peg$fail(peg$consts[bc[ip + 1]]);
              }
              ip += 2;
              break;

            case 20:
              peg$reportedPos = stack[stack.length - 1 - bc[ip + 1]];
              ip += 2;
              break;

            case 21:
              peg$reportedPos = peg$currPos;
              ip++;
              break;

            case 22:
              params = bc.slice(ip + 4, ip + 4 + bc[ip + 3]);
              for (i = 0; i < bc[ip + 3]; i++) {
                params[i] = stack[stack.length - 1 - params[i]];
              }

              stack.splice(
                stack.length - bc[ip + 2],
                bc[ip + 2],
                peg$consts[bc[ip + 1]].apply(null, params)
              );

              ip += 4 + bc[ip + 3];
              break;

            case 23:
              stack.push(peg$parseRule(bc[ip + 1]));
              ip += 2;
              break;

            case 24:
              peg$silentFails++;
              ip++;
              break;

            case 25:
              peg$silentFails--;
              ip++;
              break;

            default:
              throw new Error("Invalid opcode: " + bc[ip] + ".");
          }
        }

        if (ends.length > 0) {
          end = ends.pop();
          ip = ips.pop();
        } else {
          break;
        }
      }

      return stack[0];
    }


        function parseNumber(negative, integral, fractional) {
            negative = negative || '';
            const string = negative + integral.join('');

            if (fractional) {
                return parseFloat(string + '.' + fractional[1].join(''));
            } else {
                var number = parseInt(string);

                if (number > Number.MAX_SAFE_INTEGER) {
                    return string;
                }

                return number;
            }
        }

        function start() {
            avi.ParsedQuery = {};
            avi.ParsedQuery.complete = [];
            reset();
        }

        function reset() {
            avi.ParsedQuery.lastVariable = null;
            avi.ParsedQuery.lastVariableType = null;
            avi.ParsedQuery.lastOp = null;
            avi.ParsedQuery.lastOpType = null;
            avi.ParsedQuery.lastQueryStart = null;
        }

        function setLastVariable(value, type) {
            avi.ParsedQuery.lastVariable = value;
            avi.ParsedQuery.lastVariableType = type;
            return value;
        }

        function setLastOp(value, type) {
            var ops = {
                    '=': 'eq',
                    '!=': 'ne',
                    '>=': 'ge',
                    '>': 'gt',
                    '<=': 'le',
                    '<': 'lt',
                    '~=': 'co',
                    '!~=': 'nc',
                    '^=': 'sw'
                };
            avi.ParsedQuery.lastOp = ops[value];
            avi.ParsedQuery.lastOpType = type;
            avi.ParsedQuery.lastQueryStart = column() + value.length - 1;
            return ops[value];
        }

        function finishExpr(field, op, query, quoted) {
            var obj;
            reset();
            obj = {
                field: field,
                op: op,
                query: query,
                quoted: quoted || ''
            };
            avi.ParsedQuery.complete.push(obj);
            //console.log('Finished expression: %O', obj);
            return avi.ParsedQuery.complete[avi.ParsedQuery.complete.length - 1];
        }

        function finishArr(field, op, arr) {
            var obj;
            reset();
            obj = {
                field: field,
                op: op,
                query: arr,
                array: true
            };
            avi.ParsedQuery.complete.push(obj);
            //console.log('Finished expression: %O', obj);
            return avi.ParsedQuery.complete[avi.ParsedQuery.complete.length - 1];
        }

        function finishEventWildcard(query) {
            reset();
            if (query === "OR") {
                avi.ParsedQuery.complete.push(query);
            } else {
                 avi.ParsedQuery.complete.push({
                    field: 'all',
                    op: 'co',
                    query: query,
                    wildcard: true
                });
            }
            return avi.ParsedQuery.complete[avi.ParsedQuery.complete.length - 1];
        }

        function finishWildcard(query) {
            reset();
            avi.ParsedQuery.complete.push({
                field: 'all',
                op: 'co',
                query: query,
                wildcard: true
            });
            //console.log('Finished wildcard expression: %s', query);
            return avi.ParsedQuery.complete[avi.ParsedQuery.complete.length - 1];
        }

        function finishExprList(first, rest) {
            var ret = [first];
            for (var i = 0; i < rest.length; ++i) {
                ret.push(rest[i][1]);
            }
            return ret;
        }


    peg$result = peg$parseRule(peg$startRuleIndex);

    if (peg$result !== peg$FAILED && peg$currPos === input.length) {
      return peg$result;
    } else {
      if (peg$result !== peg$FAILED && peg$currPos < input.length) {
        peg$fail({ type: "end", description: "end of input" });
      }

      throw peg$buildException(null, peg$maxFailExpected, peg$maxFailPos);
    }
  }

  return {
    SyntaxError: SyntaxError,
    parse:       parse
  };
})();
